import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'
import { INoteFormValues } from 'features/Trips/types'
import { GTPaymentIncidencePaymentMethodInput } from 'gql/types.generated'
import { TripV2NoteCategory } from 'gql/generated/graphql'

const messages = defineMessages({
  realDistanceRequired: {
    id: 'trip.drawer.notes.realDistance.required',
    defaultMessage: 'Real Distance is required'
  },
  realDistanceValid: {
    id: 'trip.drawer.notes.realDistance.valid',
    defaultMessage: 'Enter valid Real Distance'
  },
  categoryRequired: {
    id: 'trip.drawer.notes.category.required',
    defaultMessage: 'Category is required'
  },
  operationTypeRequired: {
    id: 'trip.drawer.notes.operationType.required',
    defaultMessage: 'Operation type is required'
  },
  paymentTypeRequired: {
    id: 'trip.drawer.notes.paymentType.required',
    defaultMessage: 'Payment type is required'
  },
  cashAmountRequired: {
    id: 'trip.drawer.notes.cashAmount.required',
    defaultMessage: 'Cash amount is required'
  },
  cardAmountRequired: {
    id: 'trip.drawer.notes.cardAmount.required',
    defaultMessage: 'Card amount is required'
  },
  messageRequired: {
    id: 'trip.drawer.notes.message.required',
    defaultMessage: 'Message is required'
  }
})

const driverRSVPStatusMessages = defineMessages({
  required: {
    id: 'trip.drawer.notes.driverRSVPStatus.required',
    defaultMessage: 'You need to select a status'
  }
})

export const tripNoteSchema = (intl: IntlShape): yup.SchemaOf<INoteFormValues> => {
  return yup.object().shape({
    category: yup.string().required(intl.formatMessage(messages.categoryRequired)),
    paymentIncidents: yup.boolean().optional(),
    operationType: yup.string().when('paymentIncidents', {
      is: true,
      then: (schema) => schema.required(intl.formatMessage(messages.operationTypeRequired)),
      otherwise: (schema) => schema.optional()
    }),
    paymentType: yup.string().when('paymentIncidents', {
      is: true,
      then: (schema) => schema.required(intl.formatMessage(messages.paymentTypeRequired)),
      otherwise: (schema) => schema.optional()
    }),
    cashAmount: yup.string().when(['paymentIncidents', 'paymentType'], {
      is: (paymentIncidents: boolean, paymentType: string) => {
        return paymentIncidents && paymentType !== GTPaymentIncidencePaymentMethodInput.Card
      },
      then: (schema) =>
        schema
          .test('isMoreThanOne', intl.formatMessage(messages.cardAmountRequired), (value) => {
            return Number(value) > 0
          })
          .required(intl.formatMessage(messages.cashAmountRequired)),
      otherwise: (schema) => schema.optional()
    }),
    cardAmount: yup.string().when(['paymentIncidents', 'paymentType'], {
      is: (paymentIncidents: boolean, paymentType: string) => {
        return paymentIncidents && paymentType !== GTPaymentIncidencePaymentMethodInput.Cash
      },
      then: (schema) =>
        schema
          .test('isMoreThanOne', intl.formatMessage(messages.cardAmountRequired), (value) => {
            return Number(value) > 0
          })
          .required(intl.formatMessage(messages.cardAmountRequired)),
      otherwise: (schema) => schema.optional()
    }),
    message: yup.string().when('category', {
      is: !TripV2NoteCategory.DriverRsvp,
      then: yup.string().required(intl.formatMessage(messages.messageRequired))
    }),
    files: yup.array().of(yup.string()).optional(),
    driverRSVPStatus: yup
      .mixed()
      .nullable()
      .when('category', {
        is: TripV2NoteCategory.DriverRsvp,
        then: yup.mixed().required(intl.formatMessage(driverRSVPStatusMessages.required))
      }),
    realDistance: yup
      .mixed()
      .nullable()
      .when('category', {
        is: 'ODOMETER',
        then: yup
          .mixed()
          .required(intl.formatMessage(messages.realDistanceRequired))
          .test('isValidNumber', intl.formatMessage(messages.realDistanceValid), (value) => {
            return Number(value) > 0
          })
      })
  })
}
